<div class="tab-pane" role="tabpanel" id="formulario13" style="margin-left: -125px">
    <fieldset id="agregar_formulario13" class="">
        <div class="container" id="center_div">
            <div class="row">
                <div class="col-md-12">
                    <div id='page1' class="contenedorFormulario print-wrap page1">
                        <div>
                            <span style="float: right; clear: right;">S.R.D.O.M.-5.5.5/ 5.2.6.</span> Formulario 1.3
                            <span style="float: right; clear: right;">1/3</span>
                        </div>
                        <h1><strong>SOLICITUD DE RECEPCION DEFINITIVA DE OBRA MENOR</strong></h1>
                        <br />
                        <div>
                            <table class="title">
                                <tr>
                                    <td>
                                        <input disabled class="form-check-inline encab" type="checkbox" [checked]="tipo_solicitud[0].optradio['AMPLIACIÓN MENOR A 100 M2']" name="optradio1" id="optradio" />
                                        <label for="optradio"> AMPLIACIÓN MENOR A 100 M2</label>
                                    </td>
                                    <td>
                                        <input disabled class="form-check-inline encab" type="checkbox" [checked]="tipo_solicitud[0].optradio['MODIFICACIÓN']" name="optradio2" id="optradio" />
                                        <label for="tipo_cert"> MODIFICACI&Oacute;N</label>
                                    </td>
                                    <td>
                                        <input disabled class="form-check-inline encab" type="checkbox" [checked]="tipo_solicitud[0].optradio['ART 6 2 9 OGUC']" name="optradio3" id="optradio" />
                                        <label for="optradio"> ART 6.2.9. O.G.U.C.</label>
                                    </td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td><label for="tipo_cert">sin alterar estructura</label></td>
                                    <td></td>
                                </tr>
                            </table>
                        </div>
                        <div class="row">
                            <div class="col-md-4">
                                &nbsp;
                            </div>
                            <div class="col-md-4">
                                <h2 class="infObligatorios">
                                    <strong>DIRECCION DE OBRAS - MUNICIPALIDAD DE {{nombreMuni | uppercase}}</strong></h2>
                                <h2 class="infObligatorios"> {{region}} </h2>
                                <table class="tablaConBorde">
                                    <tr>
                                        <td>
                                            <span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span>
                                            <span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span>
                                            <input disabled class="urb" type="checkbox" name="tpradio" id="tpradio" [checked]="propiedad[0].ubicacion == 'urbano'" [checked]="propiedad[0].ubicacion == 'URBANO'" />
                                            <label for="tpradio">URBANO</label>
                                            <span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span>
                                            <span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span>
                                            <span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span>
                                            <input disabled class="urb" type="checkbox" name="tpradio" id="tpradio" [checked]="propiedad[0].ubicacion == 'rural'" [checked]="propiedad[0].ubicacion == 'RURAL'" />
                                            <label for="tpradio">RURAL</label>
                                            <span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span>
                                            <span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                            <div class="col-md-4">
                                <table style="float: right; clear: right; width: 140px;" class="tablaConBorde table">
                                    <tbody>
                                        <tr>
                                            <td align="center" class="fondoResaltado">
                                                N&Uacute;MERO SOLICITUD
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center">
                                                <input class="form-control" type="text" id="num_sol" value="" name="num_sol" disabled />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center" class="fondoResaltado">
                                                Fecha de Ingreso
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <input class="form-control" type="text" id="fecha_ingreso" value="" name="fecha_ingreso" disabled />
                                            </td>
                                        </tr>
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <td class="letraChica">
                                                * A LLENAR POR LA D.O.M
                                            </td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>
                        <br />
                        <div>
                            <table style="width: 100%;" class="tablaConBorde table">

                                <tr class="rd_tipo">
                                    <td class="fondoResaltado izquierda" rowspan="2" style="width: 40%">
                                        TIPO SOLICITUD:
                                    </td>
                                    <td><input disabled class="form-check-inline" type="checkbox" name="tipo_recepcion" id="tipo_recepcion" [checked]="tipo_recepcion[0].option == 'RECEPCION DEFINITIVA PARCIAL'" /></td>
                                    <td class="fondoResaltado">
                                        RECEPCION DEFINITIVA PARCIAL
                                    </td>
                                    <td><input disabled class="form-check-inline" type="checkbox" name="tipo_recepcion" id="tipo_recepcion" [checked]="tipo_recepcion[0].option == 'RECEPCION DEFINITIVA TOTAL' " /></td>
                                    <td class="fondoResaltado">
                                        RECEPCION DEFINITIVA TOTAL
                                    </td>

                                </tr>

                            </table>
                        </div>
                        <div>
                            <div class="tituloSeccion">
                                <span> 1.- DIRECCI&Oacute;N DE LA PROPIEDAD</span>
                                <span class="help-block"></span>
                            </div>
                            <table style="width: 100%" border="0" class="tablaConBorde table">
                                <tr class="fondoResaltado">
                                    <td style="width: 57%" colspan="3">
                                        CALLE O CAMINO
                                    </td>
                                    <td style="width: 24%">
                                        N&Uacute;MERO
                                    </td>
                                    <td style="width: 19%">
                                        ROL SII
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="3">
                                        <input disabled class="form-control" id="calle" name="calle" type="text" [(ngModel)]="propiedad[0].calle" />
                                    </td>
                                    <td>
                                        <input disabled class="form-control" id="numero" name="numero" type="text" [(ngModel)]="propiedad[0].calle_num" />
                                    </td>
                                    <td>
                                        <input disabled class="form-control" id="rol" name="rol" type="text" [(ngModel)]="propiedad[0].rol" />
                                    </td>

                                </tr>
                                <tr class="fondoResaltado">
                                    <td style="width: 11%">
                                        MANZANA
                                    </td>
                                    <td style="width: 10%">
                                        LOTE
                                    </td>
                                    <td style="width: 61%" colspan="2">
                                        LOTEO O LOCALIDAD
                                    </td>
                                    <td style="width: 18%">
                                        PLANO DE LOTEO N°
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <input disabled class="form-control" id="manzana" name="manzana" type="text" [(ngModel)]="propiedad[0].manzana" />
                                    </td>
                                    <td>
                                        <input disabled class="form-control" name="lote" id="lote" type="text" [(ngModel)]="propiedad[0].loteo" />
                                    </td>
                                    <td colspan="2">
                                        <input disabled class="form-control" id="localidad" name="localidad" type="text" [(ngModel)]="propiedad[0].localidad" />
                                    </td>
                                    <td>
                                        <input disabled class="form-control" id="loteo_numero" name="loteo_numero" type="text" [(ngModel)]="propiedad[0].plano" />
                                    </td>
                                </tr>
                            </table>

                        </div>
                        <div>
                            <div class="tituloSeccion">
                                <span>2.- DATOS DEL PROPIETARIO</span>
                                <span class="help-block"></span>
                            </div>
                            <table class="tablaConBorde table form-group clone1">
                                <tr class="fondoResaltado">
                                    <td colspan="2" style="width: 65%">
                                        NOMBRE DEL PROPIETARIO
                                    </td>
                                    <td>
                                        R.U.T.
                                    </td>
                                    <td>
                                        FIRMA DEL PROPIETARIO
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="2">
                                        <input disabled class="form-control" readonly id="nombre_prop" name="nombre_prop" type="text" [(ngModel)]="propietarios[0].nombre" />
                                    </td>
                                    <td>
                                        <input disabled class="form-control" id="rut_prop" name="rut_prop" type="text" [(ngModel)]="propietarios[0].rut" />
                                    </td>
                                    <td rowspan="7">

                                    </td>

                                </tr>
                                <tr class="fondoResaltado">
                                    <td colspan="2" style="width: 65%">
                                        REPRESENTANTE LEGAL
                                    </td>
                                    <td>
                                        R.U.T.
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="2"><input disabled class="form-control" readonly id="nombre_rep" name="nombre_rep" type="text" [(ngModel)]="representantes[0].nombre" /></td>
                                    <td><input disabled class="form-control" id="rut_rep" name="rut_rep" type="text" [(ngModel)]="representantes[0].rut" /></td>
                                </tr>

                                <tr class="fondoResaltado">
                                    <td style="width: 25%">
                                        DIRECCI&Oacute;N / CALLE / PASAJE
                                    </td>
                                    <td style="width: 25%">
                                        N°
                                    </td>
                                    <td style="width: 25%">
                                        COMUNA
                                    </td>
                                </tr>
                                <tr>
                                    <td style="width: 25%">
                                        <input disabled class="form-control" id="direccion" name="direccion" type="text" [(ngModel)]="propietarios[0].direccion" />
                                    </td>
                                    <td style="width: 25%">
                                        <input disabled class="form-control" id="num" name="num" type="text" [(ngModel)]="propietarios[0].direccion_num" />
                                    </td>
                                    <td style="width: 25%">
                                        <input disabled class="form-control" id="comuna" name="comuna" type="text" [(ngModel)]="propietarios[0].comuna" />
                                    </td>
                                </tr>
                                <tr class="fondoResaltado">
                                    <td>
                                        E-MAIL
                                    </td>
                                    <td>
                                        TEL&Eacute;FONO
                                    </td>
                                    <td>
                                        FAX
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <input disabled class="form-control" id="email_prop" name="email_prop" type="email" [(ngModel)]="propietarios[0].mail" />
                                    </td>
                                    <td>
                                        <input disabled class="form-control" id="tel_prop" name="tel_prop" type="text" [(ngModel)]="propietarios[0].fono" />
                                    </td>
                                    <td>
                                        <input disabled class="form-control" id="fax_prop" name="fax_prop" type="text" [(ngModel)]="propietarios[0].fax" />
                                    </td>
                                </tr>
                                <tr class="fondoResaltado tablaConBordeExterno table">
                                    <td colspan="4">
                                        PERSONERIA DEL REPRESENTANTE LEGAL
                                    </td>

                                </tr>
                                <tr>
                                    <td>
                                        SE ACREDITA MEDIANTE
                                    </td>
                                    <td colspan="3">
                                        <input disabled class="form-control" id="acredita" name="acredita" type="text" [(ngModel)]="permiso_notariado[0].acreditacion" />
                                    </td>

                                </tr>
                                <tr>
                                    <td>
                                        DE FECHA
                                    </td>
                                    <td>
                                        <input disabled class="form-control" id="fecha_acr" name="fecha_acr" type="text" [(ngModel)]="permiso_notariado[0].fecha" />
                                    </td>
                                    <td>
                                        Y REDUCIDA A ESCRITURA PUBLICA CON FECHA
                                    </td>
                                    <td>
                                        <input disabled class="form-control" id="fecha_esc" name="fecha_esc" type="text" [(ngModel)]="permiso_notariado[0].escritura" />
                                    </td>

                                </tr>
                                <tr>
                                    <td>
                                        ANTE EL NOTARIO SR(A)
                                    </td>
                                    <td colspan="3">
                                        <input disabled class="form-control" id="notario" name="notario" type="text" [(ngModel)]="permiso_notariado[0].notario" />
                                    </td>
                                </tr>
                            </table>
                        </div>
                        <div>
                            <div class="tituloSeccion">
                                <span>3.- ARQUITECTO PROYECTISTA</span>
                                <span class="help-block"></span>
                            </div>
                            <table class="tablaConBorde table form-group clone1">
                                <tr class="fondoResaltado">
                                    <td colspan="2" style="width: 65%"><span>
                                        NOMBRE O RAZON SOCIAL DE LA EMPRESA</span><span class="letraChica">(cuando corresponda)</span>
                                    </td>
                                    <td>
                                        R.U.T.
                                    </td>
                                    <td>
                                        FIRMA
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="2">
                                        <input disabled class="form-control" readonly id="nombre_emp" name="nombre_emp" type="text" [(ngModel)]="empresas[0].nombre" />
                                    </td>
                                    <td>
                                        <input disabled class="form-control" id="rut_emp" name="rut_emp" type="text" [(ngModel)]="empresas[0].rut" />
                                    </td>
                                    <td rowspan="5"></td>

                                </tr>
                                <tr class="fondoResaltado">
                                    <td colspan="2" style="width: 65%">
                                        NOMBRE ARQUITECTO PROYECTISTA
                                    </td>
                                    <td>
                                        R.U.T.
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="2"><input disabled class="form-control" readonly id="nombre_arq" name="nombre_arq" type="text" [(ngModel)]="arquitectos[0].nombre" /></td>
                                    <td><input disabled class="form-control" id="rut_arq" name="rut_arq" type="text" [(ngModel)]="arquitectos[0].rut" /></td>
                                </tr>

                                <tr class="fondoResaltado">
                                    <td style="width: 25%">
                                        DIRECCI&Oacute;N / CALLE / PASAJE
                                    </td>
                                    <td style="width: 25%">
                                        N°
                                    </td>
                                    <td style="width: 25%">
                                        COMUNA
                                    </td>
                                </tr>
                                <tr>
                                    <td style="width: 25%">
                                        <input disabled class="form-control" id="direccion" name="direccion" type="text" [(ngModel)]="arquitectos[0].direccion" />
                                    </td>
                                    <td style="width: 25%">
                                        <input disabled class="form-control" id="num" name="num" type="text" [(ngModel)]="arquitectos[0].direccion_num" />
                                    </td>
                                    <td style="width: 25%">
                                        <input disabled class="form-control" id="comuna" name="comuna" type="text" [(ngModel)]="arquitectos[0].comuna" />
                                    </td>
                                </tr>
                                <tr class="fondoResaltado">
                                    <td>
                                        E-MAIL
                                    </td>
                                    <td>
                                        TEL&Eacute;FONO
                                    </td>
                                    <td>
                                        FAX
                                    </td>
                                    <td>
                                        PATENTE PROFESIONAL N°
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <input disabled class="form-control" id="email_arq" name="email_arq" type="email" [(ngModel)]="arquitectos[0].mail" />
                                    </td>
                                    <td>
                                        <input disabled class="form-control" id="tel_arq" name="tel_arq" type="text" [(ngModel)]="arquitectos[0].fono" />
                                    </td>
                                    <td>
                                        <input disabled class="form-control" id="fax_arq" name="fax_arq" type="text" [(ngModel)]="arquitectos[0].fax" />
                                    </td>
                                    <td>
                                        <input disabled class="form-control" id="pat_arq" name="pat_arq" type="text" [(ngModel)]="arquitectos[0].patente" />
                                    </td>
                                </tr>
                            </table>
                        </div>
                        <div><span CLASS="letraChica">NOTA: DE HABER MAS DE UN PROFESIONAL RESPONSABLE, ADJUNTAR DOCUMENTO CON FORMATO SIMILAR AL ANTERIOR QUE CONTENGA LOS DATOS NECESARIOS</span></div>
                        <div>
                            <div class="tituloSeccion">
                                <span>4.- REVISOR INDEPENDIENTE</span>
                                <span class="help-block"></span>
                            </div>
                            <table class="tablaConBorde table form-group">
                                <tr>
                                    <td colspan="3" class="fondoResaltado izquierda"><span>
                                           CUENTA CON INFORME FAVORABLE REVISOR INDEPENDIENTE</span>
                                    </td>
                                    <td align="center"><input type="checkbox" disabled class="form-check-inline" readonly id="informe" name="informe" [checked]="informe[0].infradio == 'SI'" /><span>SI</span></td>
                                    <td align="center"><input type="checkbox" disabled class="form-check-inline" readonly id="informe" name="informe" [checked]="informe[0].infradio == 'NO'" /><span>NO</span></td>
                                    <td colspan="2"><span>N°</span></td>
                                    <td><span><input disabled class="form-control" readonly id="numero" name="numero" type="text" [(ngModel)]="informe[0].num_informe"/></span></td>
                                    <td colspan="2"><span>Fecha</span></td>
                                    <td><span><input disabled class="form-control" readonly id="fecha" name="fecha" type="text" [(ngModel)]="informe[0].fech_informe" /></span></td>
                                </tr>
                                <tr>
                                    <td class="fondoResaltado" colspan="12"><span>NOMBRE REVISOR INDEPENDIENTE</span></td>
                                </tr>
                                <tr>
                                    <td colspan="12">
                                        <input disabled class="form-control" id="nombre_ind" name="nombre_ind" type="text" [(ngModel)]="independiente[0].nombre" />
                                    </td>
                                </tr>
                                <tr class="fondoResaltado">
                                    <td colspan="2">R.U.T.</td>
                                    <td colspan="3">EMAIL</td>
                                    <td colspan="3">TELEFONO / FAX</td>
                                    <td colspan="2">CATEGORIA</td>
                                    <td colspan="2">REGISTRO</td>
                                </tr>
                                <tr>
                                    <td colspan="2"><input disabled class="form-control" readonly id="rut_ind" name="rut_ind" type="text" [(ngModel)]="independiente[0].rut" /></td>
                                    <td colspan="3"><input disabled class="form-control" readonly id="email_ind" name="email_ind" type="text" [(ngModel)]="independiente[0].mail" /></td>
                                    <td colspan="3"><input disabled class="form-control" readonly id="telf_ind" name="telf_ind" type="text" [(ngModel)]="independiente[0].fono" /></td>
                                    <td colspan="2"><input disabled class="form-control" readonly id="cat_ind" name="cat_ind" type="text" [(ngModel)]="independiente[0].categoria" /></td>
                                    <td colspan="2"><input disabled class="form-control" readonly id="reg_ind" name="reg_ind" type="text" [(ngModel)]="independiente[0].registro" /></td>
                                </tr>
                            </table>
                        </div>
                        <br />
                        <br />
                    </div>


                    <div id='page2' class="contenedorFormulario print-wrap page2">
                        <div>
                            <span style="float: right; clear: right;">(S.R.D.O.M.-5.5.5/ 5.2.6.)</span> Formulario 1.3
                            <span style="float: right; clear: right;">2/3</span>
                        </div>
                        <br />
                        <div>
                            <div class="tituloSeccion">
                                <span>5.- DATOS DEL PROYECTO</span>
                                <span class="help-block"></span>
                            </div>
                            <table class="tablaConBorde table form-group">
                                <tr class="fondoResaltado">
                                    <td align="center" style="width: 10%">
                                        <input class="form-check-inline" type="checkbox" id="datos_proy" value="CONSIDERA CAMBIOS DE DESTINO" name="datos_proy" [checked]="datos_proyecto[0].datos == 'SI'" disabled />
                                    </td>
                                    <td style="width: 40%"><span>
                                        CONSIDERA CAMBIOS DE DESTINO</span>
                                    </td>

                                    <td align="center" style="width: 10%">
                                        <input class="form-check-inline" type="checkbox" id="datos_proy" value="GENERA NUEVAS UNIDADES" name="datos_proy" [checked]="datos_proyecto[0].datos == 'NO'" disabled />
                                    </td>

                                    <td>
                                        GENERA NUEVAS UNIDADES
                                    </td>

                                </tr>

                            </table>

                        </div>

                        <div>
                            <div class="tituloSeccion">
                                <span>6.- PERMISOS Y RESOLUCIONES</span>
                                <span class="help-block"></span>
                            </div>
                            <table class="tablaConBorde table form-group">
                                <tr class="fondoResaltado">
                                    <td colspan="2" rowspan="2">PERMISO PARA EL QUE SOLICITA ESTA RECECION</td>
                                    <td colspan="2">N°</td>
                                    <td colspan="2">FECHA</td>
                                    <td colspan="2">SUPERFICIE M2</td>
                                </tr>
                                <tr>
                                    <td colspan="2"><input disabled class="form-control" readonly id="permiso_num" name="permiso_num" type="text" [(ngModel)]="permisos[0].perm_numero" /></td>
                                    <td colspan="2"><input disabled class="form-control" readonly id="permiso_fecha" name="permiso_fecha" type="text" [(ngModel)]="permisos[0].perm_fecha" /></td>
                                    <td colspan="2"><input disabled class="form-control" readonly id="permiso_sup" name="permiso_sup" type="text" [(ngModel)]="permisos[0].superfm2" /></td>
                                </tr>
                                <tr>
                                    <td colspan="2" class="fondoResaltado" style="width: 20%">CUENTA CON MODIFICACION DE PROYECTO APROBADA</td>
                                    <td align="center" style="width: 10%"><input class="form-check-inline" type="checkbox" id="mod_aprob" name="mod_aprob" value="SI" disabled [checked]="permisos[0].modproy == 'SI'" />SI</td>
                                    <td align="center" style="width: 10%"><input class="form-check-inline" type="checkbox" id="mod_aprob" name="mod_aprob" value="NO" disabled [checked]="permisos[0].modproy == 'NO'" />NO</td>
                                    <td class="fondoResaltado" style="width: 20%">Resoluci&oacute;n N°</td>
                                    <td style="width: 10%"><input disabled class="form-control" readonly id="resolucion" name="resolucion" type="text" [(ngModel)]="permisos[0].resolucion" /></td>
                                    <td class="fondoResaltado" style="width: 20%">Fecha</td>
                                    <td style="width: 10%"><input disabled class="form-control" readonly id="fecha_resol" name="fecha_resol" type="text" [(ngModel)]="permisos[0].fecha_resol" /></td>
                                </tr>
                                <tr>
                                    <td class="fondoResaltado">PERMISO PRIMITIVO N°</td>
                                    <td><input disabled class="form-control" readonly id="perm_prim" name="perm_prim" type="text" [(ngModel)]="permisos[0].perm_prim" /></td>
                                    <td class="fondoResaltado">DE FECHA</td>
                                    <td><input disabled class="form-control" readonly id="perm_fech" name="perm_fech" type="text" [(ngModel)]="permisos[0].fecha_prim" /></td>
                                    <td class="fondoResaltado">Recepci&oacute;n N°</td>
                                    <td><input disabled class="form-control" readonly id="recepcion" name="recepcion" type="text" [(ngModel)]="permisos[0].recepcion" /></td>
                                    <td class="fondoResaltado">Fecha</td>
                                    <td><input disabled class="form-control" readonly id="fecha_recep" name="fecha_recep" type="text" [(ngModel)]="permisos[0].fecha_recep" /></td>
                                </tr>
                            </table>
                        </div>
                        <div>
                            <div class="tituloSeccion">
                                <span>7.- CARACTERISTICAS DEL PROYECTO</span>
                                <span class="help-block"></span>
                            </div>
                            <table class="tablaConBorde table form-group">
                                <tr class="fondoResaltado">
                                    <td colspan="2">DESTINO PRINCIPAL DE LA EDIFICACIÓN</td>
                                    <td>SUP. TOTAL PROYECTADA</td>
                                    <td>N° PISOS SOBRE TERRENO</td>
                                </tr>
                                <tr>
                                    <td colspan="2"><input disabled class="form-control" readonly id="destino1" name="destino1" type="text" [(ngModel)]="caracteristica_proyecto[0].destino" /></td>

                                    <td><input disabled class="form-control" readonly id="supproy" name="supproy" type="text" [(ngModel)]="caracteristica_proyecto[0].supertotal" /></td>
                                    <td><input disabled class="form-control" readonly id="npisos" name="npisos" type="text" [(ngModel)]="caracteristica_proyecto[0].npisos" /></td>
                                </tr>

                            </table>
                            <br />

                            <table class="tablaConBorde table form-group">
                                <tr>
                                    <td colspan="8" class="fondoResaltado izquierda"><span>HA HABIDO CAMBIOS EN EL PROYECTO APROBADO</span><span class="letraChica"> (ART. 5.2.8 OGUC)</span></td>
                                    <td align="center"><input type="checkbox" disabled class="form-check-inline" readonly id="cambios_aprob" name="cambios_aprob" value="SI" [checked]="caracteristica_proyecto[0].modradio == 'SI'" />
                                        <span>SI</span></td>
                                    <td align="center"><input type="checkbox" disabled class="form-check-inline" readonly id="cambios_aprob" name="cambios_aprob" value="NO" [checked]="caracteristica_proyecto[0].modradio == 'NO'" />
                                        <span>NO</span></td>
                                </tr>
                                <tr>
                                    <td colspan="8" class="fondoResaltado izquierda">EDIFICIO DE USO PUBLICO</td>
                                    <td align="center"><input type="checkbox" disabled class="form-check-inline" readonly id="uso_pub" name="uso_pub" value="SI" [checked]="caracteristica_proyecto[0].usoradio == 'SI'" />
                                        <span>SI</span></td>
                                    <td align="center"><input type="checkbox" disabled class="form-check-inline" readonly id="uso_pub" name="uso_pub" value="NO" [checked]="caracteristica_proyecto[0].usoradio == 'NO'" />
                                        <span>NO</span></td>
                                </tr>
                            </table>

                        </div>
                        <div>
                            <div class="tituloSeccion">
                                <span>8.- RECEPCION PARCIAL</span>
                                <span class="help-block"></span>
                            </div>
                            <table class="tablaConBorde table form-group">
                                <tr>
                                    <td class="fondoResaltado">SUPERFICIE EDIFICADA QUE SE RECEPCIONA</td>
                                    <td><input disabled class="form-control" readonly id="superf_edif" name="superf_edif" type="text" [(ngModel)]="recepcion[0].superedif" /></td>
                                    <td class="fondoResaltado">DESTINO CONTEMPLADO</td>
                                    <td><input disabled class="form-control" readonly id="destino" name="destino" type="text" [(ngModel)]="recepcion[0].destino_cont" /></td>
                                </tr>
                            </table>
                        </div>
                        <br />
                        <div>
                            <div class="tituloSeccion">
                                <span>9.- ANTECEDENTES QUE SE ADJUNTAN</span>
                                <span class="help-block"></span>
                                <span class="letraChica">(ART. 5.2.6/1.2.1/1.4.2. OGUC)</span>
                            </div>

                            <table class="tablaConBorde table form-group">
                                <tr class="fondoResaltado">
                                    <td style="width: 10%"></td>
                                    <td colspan="2"></td>

                                </tr>
                                <tr>

                                    <td align="center" style="width: 10%"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos"  checked disabled/></td>
                                    <td><span>Fotocopia de la patente municipal al dia de los Profesionales competentes</span></td>

                                </tr>
                                <tr>

                                    <td align="center" style="width: 10%"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" checked disabled/></td>
                                    <td><span>Informe del arquitecto autor del proyecto Art. 5.2.6 O.G.U.C inciso final</span></td>

                                </tr>
                                <tr>

                                    <td align="center" style="width: 10%"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" checked disabled/></td>
                                    <td><span>Planos de Obra Terminada en caso de modificaciones menores Art. 5.2.8. O.G.U.C.</span></td>

                                </tr>
                                <tr>

                                    <td align="center" style="width: 10%"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" /></td>
                                    <td><span>Informe del Revisor Independiente (Si ocurre)</span></td>

                                </tr>
                                <tr>

                                    <td align="center" style="width: 10%"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" /></td>
                                    <td><span>Informe del Inspector Tecnico de Obras (ITO) (cuando corresponda)</span></td>

                                </tr>
                            </table>


                        </div>
                        <br />
                        <div class="tablaConBordeExterno">
                            <span>CERTIFICADOS DE LAS INSTALACIONES CONTEMPLADAS EN LA OBRA: </span>
                            <span><input disabled class="form-control" readonly id="certificados" name="certificados" type="textarea" /></span>
                        </div>
                        <br />
                        <br />
                        <br />
                        <br />
                    </div>

                    <div id='page3' class="contenedorFormulario print-wrap page3">
                        <div>
                            <span style="float: right; clear: right;">(S.R.D.O.M.-5.5.5/ 5.2.6.)</span> Formulario 1.3
                            <span style="float: right; clear: right;">3/3</span>
                        </div>
                        <br />
                        <div>
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />
                        </div>
                        <hr />
                        <div>
                            <div><span style="float: right; clear: right;">(S.R.D.O.M.-5.5.5/ 5.2.6.)</span></div>
                            <div>
                                <h1><strong>COMPROBANTE DE INGRESO</strong></h1>
                            </div>
                        </div>
                        <br />

                        <div>
                            <h1>SOLICITUD DE RECPCION DEFINITIVA DE OBRA MENOR</h1>
                        </div>
                        <br />
                        <div class="row">
                            <div class="col-md-4">
                                <table class="tablaConBordeExterno">
                                    <tr>
                                        <td>&nbsp;</td>
                                    </tr>
                                    <tr>
                                        <td>&nbsp;</td>
                                    </tr>
                                    <tr>
                                        <td>&nbsp;</td>
                                    </tr>
                                    <tr>
                                        <td>&nbsp;</td>
                                    </tr>
                                    <tr>
                                        <td>&nbsp;</td>
                                    </tr>
                                    <tr>
                                        <td>&nbsp;</td>
                                    </tr>
                                    <tr align="center">
                                        <td>FIRMA FUNCIONARIO.</td>
                                    </tr>
                                    <tr align="center">
                                        <td> Y TIMBRE D.O.M.</td>
                                    </tr>

                                </table>

                            </div>
                            <br />
                            <div class="col-md-4">
                                <h2 class="infObligatorios">
                                    <strong> DIRECCION DE OBRAS - MUNICIPALIDAD DE {{nombreMuni | uppercase}}</strong></h2>
                                <h2 class="infObligatorios"> {{region}} </h2>
                            </div>
                            <div class="col-md-4">
                                <table style="float: right; clear: right; width: 140px;" class="tablaConBorde table">
                                    <tbody>
                                        <tr>
                                            <td align="center" class="fondoResaltado">
                                                N&Uacute;MERO SOLICITUD
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center">
                                                <input class="form-control" type="text" id="num_sol" value="" name="num_sol" disabled />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td align="center" class="fondoResaltado">
                                                Fecha de Ingreso
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <input class="form-control" type="text" id="fecha_ingreso" value="" name="fecha_ingreso" disabled />
                                            </td>
                                        </tr>
                                    </tbody>

                                </table>
                            </div>
                        </div>
                        <br />
                        <div>
                            <table class="tablaConBorde">
                                <tr class="fondoResaltado">
                                    <td>CALLE O CAMINO</td>
                                    <td>N&Uacute;MERO</td>
                                </tr>
                                <tr>
                                    <td><input class="form-control" type="text" id="calle" name="calle" disabled [(ngModel)]="propiedad[0].calle" /></td>
                                    <td><input class="form-control" type="text" id="numero" name="numero" disabled [(ngModel)]="propiedad[0].calle_num" /></td>
                                </tr>
                            </table>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <div>
            <button mat-raised-button color="primary" id="pdf-download-link" title="Descargar Formulario 1.3" (click)="captureScreen()">Descargar Formulario 1.3</button>
        </div>
    </fieldset>
</div>